import React from 'react'
import { useTranslation } from 'react-i18next'
import Banner from '../components/Banner'
import Section1 from '../components/about/Section1'
import Section2 from '../components/about/Section2'
import Section3 from '../components/about/Section3'

const AboutPage = () => {
  const { t } = useTranslation();

  const bannerData = {
    title: t('about.title'),
    img: '/images/about/about.jpg'
  }

  return (
    <div>
      <div className='grid grid-cols-10'>
        <div className='col-start-2 col-span-8 '>
          <Banner bannerData={bannerData} />
          <Section1 />
          <Section2 />
        </div>
      </div>
      <Section3 />
    </div>
  )
}

export default AboutPage
